export const GET_SHELVES = 'GET_SHELVES';
export const GET_SHELF = 'GET_SHELF';
export const FLAG_GETTING_SHELVES = 'FLAG_GETTING_SHELVES';
export const FLAG_SHELF_ACTIVITY = 'FLAG_SHELF_ACTIVITY';
export const CLEAR_SHELF = 'CLEAR_SHELF';
export const CLEAR_SHELVES = 'CLEAR_SHELVES';
export const GET_SHELF_SPACE = 'GET_SHELF_SPACE';

export const GET_SHELF_SPACES = 'GET_SHELF_SPACES';
export const FLAG_GETTING_SHELF_SPACES = 'FLAG_GETTING_SHELF_SPACES';
export const CLEAR_SHELF_SPACES = 'CLEAR_SHELF_SPACES';
